import './footer.css';
import Reveal from './Reveal';
import { CONTACT_EMAILS, WHATSAPP_DISPLAY, WHATSAPP_URL } from '../config/site';
import { getDestinationZoneHash, getLocationById } from '../data/locations';
import moriLogo from '../assets/images/mori_logo-removebg-preview.png';

const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Tanzania Mainland', href: '#tanzania-mainland' },
  { label: 'Tanzania Island', href: '#tanzania-island' },
  { label: 'Safaris', href: '#safaris' },
  { label: 'Trekking', href: '#trekking' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

const FEATURED_DESTINATIONS = [
  'serengeti',
  'ngorongoro',
  'kilimanjaro',
  'zanzibar',
  'tarangire',
].map((id) => getLocationById(id)).filter(Boolean);

const CURRENT_YEAR = new Date().getFullYear();

function FooterLogo() {
  return (
    <img
      className="site-footer__logo-img"
      src={moriLogo}
      alt=""
      width={88}
      height={88}
      decoding="async"
      aria-hidden="true"
    />
  );
}

function Footer() {
  return (
    <footer className="site-footer" id="contact">
      {/* CTA strip */}
      <div className="site-footer__cta-band">
        <div className="page-container site-footer__cta-inner">
          <Reveal className="site-footer__cta-text" variant="right">
            <p className="site-footer__cta-eyebrow">Plan with locals</p>
            <h2 className="site-footer__cta-title">Your Tanzania safari starts here</h2>
            <p className="site-footer__cta-desc">
              Free itinerary advice we reply within 24 hours.
            </p>
          </Reveal>
          <Reveal className="site-footer__cta-actions" variant="left" delay={150}>
            <a
              className="site-footer__btn site-footer__btn--whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp us
            </a>
            <a className="site-footer__btn site-footer__btn--email" href={CONTACT_EMAILS[0].href}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              {CONTACT_EMAILS[0].label}
            </a>
            <a className="site-footer__btn site-footer__btn--email" href={CONTACT_EMAILS[1].href}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              {CONTACT_EMAILS[1].label}
            </a>
          </Reveal>
        </div>
      </div>

      {/* Main footer */}
      <div className="site-footer__main">
        <div className="page-container">
          <Reveal className="site-footer__layout" variant="fade" delay={100}>
            <div className="site-footer__brand-block">
              <a className="site-footer__brand" href="/">
                <span className="site-footer__logo">
                  <FooterLogo />
                </span>
                <span className="site-footer__brand-text">
                  <span className="site-footer__name">Mori Tours</span>
                  <span className="site-footer__tagline">Tanzania Safari &amp; Travel</span>
                </span>
              </a>
              <p className="site-footer__about">
                Custom safaris, Kilimanjaro treks, and Zanzibar escapes every journey
                built around the places you want to explore.
              </p>
              <ul className="site-footer__badges">
                <li>Licensed operator</li>
                <li>Based in Arusha</li>
                <li>Tailor-made trips</li>
              </ul>
              <ul className="site-footer__social" aria-label="Social media">
                <li>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>

            <div className="site-footer__links-block">
              <nav className="site-footer__nav" aria-labelledby="footer-explore-heading">
                <h2 id="footer-explore-heading">Explore</h2>
                <ul>
                  {NAV_LINKS.map((link) => (
                    <li key={link.href}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </nav>
              <nav className="site-footer__nav" aria-labelledby="footer-destinations-heading">
                <h2 id="footer-destinations-heading">Destinations</h2>
                <ul>
                  {FEATURED_DESTINATIONS.map((location) => (
                    <li key={location.id}>
                      <a href={getDestinationZoneHash(location)}>{location.name}</a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="site-footer__contact-card">
              <h2 id="footer-contact-heading">Visit us</h2>
              <address aria-labelledby="footer-contact-heading">
                <div className="site-footer__contact-item">
                  <span className="site-footer__contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </span>
                  <div>
                    <span className="site-footer__contact-label">Office</span>
                    <p>Arusha & Kilimanjaro, Tanzania</p>
                  </div>
                </div>
                <div className="site-footer__contact-item">
                  <span className="site-footer__contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <div>
                    <span className="site-footer__contact-label">Email</span>
                    {CONTACT_EMAILS.map((email) => (
                      <p key={email.label}>
                        <a href={email.href}>{email.label}</a>
                      </p>
                    ))}
                  </div>
                </div>
                <div className="site-footer__contact-item">
                  <span className="site-footer__contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                    </svg>
                  </span>
                  <div>
                    <span className="site-footer__contact-label">WhatsApp</span>
                    <p>
                      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                        {WHATSAPP_DISPLAY}
                      </a>
                    </p>
                  </div>
                </div>
              </address>
            </div>
          </Reveal>

          <Reveal className="site-footer__destinations-row" aria-label="Popular destinations" variant="fade" delay={200}>
            <span className="site-footer__destinations-label">Popular:</span>
            <ul className="site-footer__chips">
              {FEATURED_DESTINATIONS.map((location) => (
                <li key={location.id}>
                  <a href={getDestinationZoneHash(location)}>{location.name.split(' ')[0]}</a>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="page-container site-footer__bottom-inner">
          <p className="site-footer__copy">
            &copy; {CURRENT_YEAR} Mori Tours · Tanzania
          </p>
          <ul className="site-footer__legal">
            <li><a href="#privacy">Privacy</a></li>
            <li><a href="#terms">Terms</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
